// Textos y formato compartidos de los contratos (tablero, detalle y tarjeta del ticket).

export const MODEL_LABEL = { bag: 'Bolsa de horas', baseline: 'Baseline', on_demand: 'On Demand' } as const;

const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
export const monthLabel = (m: string | null | undefined) => {
  if (!m) return '—';
  const [y, mm] = m.split('-').map(Number);
  return `${MONTHS[(mm ?? 1) - 1]} ${y}`;
};

export const h = (n: number) => `${Number.isInteger(n) ? n : n.toFixed(1)} h`;

/** Tono por nivel: verde en orden, ámbar con aviso, rojo excedido / fuera de banda. */
export const LEVEL = {
  ok: { bar: 'bg-accent', text: 'text-accent-dark', chip: 'bg-accent-soft text-accent-dark', label: 'En orden' },
  alert: { bar: 'bg-[#D98E04]', text: 'text-[#6A3A00]', chip: 'bg-[#FFF4E5] text-[#6A3A00]', label: 'Arriba del 85 %' },
  band: { bar: 'bg-[#D98E04]', text: 'text-[#6A3A00]', chip: 'bg-[#FFF4E5] text-[#6A3A00]', label: 'En banda' },
  over: { bar: 'bg-[#C0392B]', text: 'text-[#8F1D1D]', chip: 'bg-[#FBEAEA] text-[#8F1D1D]', label: 'Excedida' },
  out: { bar: 'bg-[#C0392B]', text: 'text-[#8F1D1D]', chip: 'bg-[#FBEAEA] text-[#8F1D1D]', label: 'Fuera de banda' },
  not_started: { bar: 'bg-[#B8B3AA]', text: 'text-muted', chip: 'bg-[#EDEBE7] text-muted', label: 'Por iniciar' },
  ended: { bar: 'bg-[#B8B3AA]', text: 'text-muted', chip: 'bg-[#EDEBE7] text-muted', label: 'Terminado' }
} as const;
export type LevelKey = keyof typeof LEVEL;

export function Meter({ pct, level, label }: { pct: number; level: LevelKey; label: string }) {
  const w = Math.max(0, Math.min(100, Math.round(pct * 100)));
  return (
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-[#EFEDE9]" role="progressbar" aria-label={label} aria-valuenow={w} aria-valuemin={0} aria-valuemax={100}>
      <div className={`h-full rounded-full ${LEVEL[level].bar}`} style={{ width: `${w}%` }} />
    </div>
  );
}
